import { Component, OnInit } from '@angular/core';
import { CustomerModel, LocationCreateModelFile } from '@kanzi-apes/kanzi-models';
import { MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import { BreadcrumbService } from '@kanzi-apes/kanzi-ui';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { select, Store } from '@ngrx/store';
import * as fromLocations from '../../reducers';
import * as Locations from '../../actions';
import { Observable } from 'rxjs';
import * as fromCustomer from '@kanzi-apes/kanzi-customer';
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-location-create',
    templateUrl: './location-create.component.html',
    styleUrls: ['./location-create.component.scss'],
    standalone: false
})
export class LocationCreateComponent implements OnInit {

  customerSelected$: Observable<CustomerModel | null> = this.store.pipe(
    select(fromCustomer.getCustomerSelected)
  );
  
  isLoadFileMasterLocations:boolean;
  isDisplayModal:boolean;
  formatCsv:string;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private envService:EnvironmentService,
    private store: Store<fromLocations.State>,

  ) {
    this.isLoadFileMasterLocations=this.envService.environment?.modules.loadMasterFileLocation as boolean;
    this.isDisplayModal=false;
    this.formatCsv = 'https://s-technoapes-nki.s3.amazonaws.com/media/public/master-locations/formats/MASTER_LOCATION.csv'
  }

  ngOnInit() {
    this.breadcrumbService.setItems([
      {
        label: 'Crear una locación',
        icon: 'fa-plus',
      },
    ]);
    
  }

  downloadFormat(){
    window.location.href = this.formatCsv
  }

  showDialogFileAdd(){
    this.isDisplayModal=true
  }

  closeModal($event:any){
    this.isDisplayModal=false
  }

  upLoadMasterFile(data:LocationCreateModelFile){
    this.store.dispatch(new Locations.LoadMasterFile(data))
  }
}
